import { useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { CouponTypeEnum } from "../schema/coupon-schema";

export default function TypeFilter() {
  const [searchParams, setSearchParams] = useSearchParams();

  const type = searchParams.get("type") || "ALL";

  const form = useForm({
    defaultValues: {
      type,
    },
  });

  const handleTypeChange = (newType: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "0");
    
    if (newType === "ALL") {
      newParams.delete("type");
    } else {
      newParams.set("type", newType);
    }
    
    setSearchParams(newParams);
    form.setValue("type", newType);
  };

  const handleReset = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "0");
    const search = searchParams.get("search");
    const status = searchParams.get("status");
    if (search) newParams.set("search", search);
    if (status) newParams.set("status", status);
    newParams.delete("type");
    setSearchParams(newParams);
    form.reset({ type: "ALL" });
  };

  const hasFilters = type && type !== "ALL";

  const typeOptions = [
    { value: "ALL", label: "All Types" },
    { value: CouponTypeEnum.CAMPAIGN, label: "Campaign" },
    { value: CouponTypeEnum.INTERNAL, label: "Internal" },
    { value: CouponTypeEnum.COMMUNITY, label: "Community" },
    { value: CouponTypeEnum.B2B, label: "B2B" },
    { value: CouponTypeEnum.B2B2C, label: "B2B2C" },
    { value: CouponTypeEnum.AFFILIATE, label: "Affiliate" },
  ];

  return (
    <Form {...form}>
      <div className="flex items-center gap-4">
        <FormField
          control={form.control}
          name="type"
          render={({ field }) => (
            <FormItem>
              <Select
                value={field.value}
                onValueChange={handleTypeChange}
              >
                <FormControl>
                  <SelectTrigger className="w-[180px]">
                    <SelectValue placeholder="Type" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {typeOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FormItem>
          )}
        />

        {hasFilters && (
          <Button
            type="button"
            variant="outline"
            onClick={handleReset}
          >
            <X className="h-4 w-4 mr-1" />
            Reset
          </Button>
        )}
      </div>
    </Form>
  );
}

